import type { CSSProperties } from 'react';

type TrackStyle = CSSProperties & Record<`--${string}`, string>;

/**
 * Feeds a position on the axis to the SCSS as custom properties instead of inline geometry.
 * The percentage is of the axis; while zoomed the drawn track also holds future weeks, so it
 * is scaled by the axis's share of the track (`--data-share`, 1 when there are none).
 */
export function trackStyle(leftPct: number, widthPct?: number): TrackStyle {
    const scaled = (pct: number) => `calc(${pct}% * var(--data-share, 1))`;
    return widthPct === undefined
        ? { '--left': scaled(leftPct) }
        : { '--left': scaled(leftPct), '--width': scaled(widthPct) };
}

/** A position already in percent of the whole drawn track, future weeks included: the header. */
export function drawnTrackStyle(leftPct: number, widthPct: number): TrackStyle {
    return { '--left': `${leftPct}%`, '--width': `${widthPct}%` };
}

/**
 * The axis's week count and the future weeks drawn after it, which set the track's minimum
 * width at a fixed-width zoom and the axis's share of the track.
 */
export function weekCountStyle(weekCount: number, futureWeeks: number): TrackStyle {
    return { '--week-count': String(weekCount), '--future-weeks': String(futureWeeks) };
}
